import { Injectable } from "@angular/core";
import { Router } from "@angular/router";

export enum OrigemImportacao {
  GestaoCartaoNoName = "gestao-lote-cartao",
  GestaoFuncionarios = "gestao-funcionarios",
  GestaoSaldo = "gestao-saldo",
  Desconhecido = "desconhecido",
}

@Injectable({
  providedIn: "root",
})
export class OrigemImportacaoService {
  constructor(private router: Router) {}

  /**
   * Obtém a origem da importação com base na URL.
   * @returns {OrigemImportacao} A origem identificada.
   */
  getOrigemImportacao(): OrigemImportacao {
    const url = this.router.url;
    const segments = url.split("/");

    return (
      ((Object.values(OrigemImportacao) as string[]).find((segment) =>
        segments.includes(segment)
      ) as OrigemImportacao) || OrigemImportacao.Desconhecido
    );
  }

  /**
   * Converte uma origem em um valor de emissão de cartão.
   * @param origem A origem da importação.
   * @returns {'SIM' | 'NAO'} 'SIM' para GestaoFuncionarios, 'NAO' para outras origens.
   */
  getEmitirCartao(origem: OrigemImportacao): "SIM" | "NAO" {
    return origem === OrigemImportacao.GestaoCartaoNoName ? "NAO" : "SIM";
  }
}
